import { render, staticRenderFns } from "./MinecraftPlayers.vue?vue&type=template&id=1b7af9a6&"
import script from "./MinecraftPlayers.vue?vue&type=script&lang=js&"
export * from "./MinecraftPlayers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports